import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters.");
    setLoading(true);
    try {
      const u = await register(name, email, password);
      toast.success(`Welcome aboard, ${u.name || u.email}`);
      nav("/");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-24">
      <div className="overline text-accent mb-3">Create account</div>
      <h1 className="font-editorial text-4xl text-primary tracking-tight">Join VDE.</h1>
      <p className="text-muted-foreground mt-2 text-sm">Save your intake and stay in the loop.</p>

      <form onSubmit={submit} className="mt-10 space-y-5">
        <div><Label>Full name</Label><Input required value={name} onChange={(e) => setName(e.target.value)} className="mt-2 rounded-none" data-testid="register-name" /></div>
        <div><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-none" data-testid="register-email" /></div>
        <div><Label>Password</Label><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-none" data-testid="register-password" /></div>
        <Button type="submit" disabled={loading} className="w-full rounded-full h-11" data-testid="register-submit">
          {loading ? "Creating…" : "Create account"}
        </Button>
      </form>

      <p className="text-sm text-muted-foreground mt-8 text-center">
        Already have an account? <Link to="/login" className="text-primary link-underline" data-testid="register-login-link">Sign in</Link>
      </p>
    </div>
  );
}
